import React from 'react';
import styles from './ListItem.module.css';

type ListItemProps = {
  children: React.ReactNode;
  active?: boolean;
};

const ListItem = ({ children, active }: ListItemProps) => {
  return (
    <li className={`${styles.container} ${active ? styles.active : ''}`}>
      {children}
    </li>
  );
};

export default ListItem;
